import { useMailScope } from "./mailScope";
import { useQuery } from "@tanstack/react-query";
import { Alert, Descriptions, Space, Table, Tag } from "antd";
import { useApi } from "../../lib/useApi";
import { PageHeader } from "../../ui";
import { MailHelp } from "./MailHelp";
import { mailError } from "./mailUtils";

export function MailStatusPage() {
  const api = useApi();
  const scope = useMailScope();
  const query = useQuery({ queryKey: ["dlp", "mail", scope, "status"], queryFn: api.mailStatus, gcTime: 0, retry: false, refetchInterval: 30_000 });
  const s = query.isError ? undefined : query.data;
  return <div className="ui-list"><div className="ui-list-main">
    <PageHeader title="メールの状態" description="送出結果の「リレー受理」は Google が引き受けた状態です。その先の配送は Google の責任です。" />
    <MailHelp />
    <Space direction="vertical" style={{ width: "100%" }}>
      <Alert type="info" showIcon message="gateway 停止中は社外宛てが出ず、Gmail が最大 7 日再送します" description="復旧後は次の再送時に届き、最大で直前の再送間隔ぶん遅れます(時間がたつほど長い)。GWS の規則の無効化は滞留分を救いません。gateway を先に復旧してください。災害時は最後のバックアップ以降を失い得ます。保留分はできる限り残すが保証しません。復元後の未送出宛先は結果不明として人が判断します。" />
      {query.isError && <Alert type="error" message={mailError(query.error)} />}
      {s && <>
        <Descriptions bordered column={2} title="gateway" items={Object.entries(s.gateway).map(([key, value]) => ({ key, label: key, children: typeof value === "boolean" ? (value ? "稼働" : "停止") : value ?? "—" }))} />
        <Descriptions bordered column={2} title="キュー" items={Object.entries(s.queue).map(([key, value]) => ({ key, label: key, children: value }))} />
        <Descriptions bordered column={2} title="スプール" items={Object.entries(s.spool).map(([key, value]) => ({ key, label: key, children: typeof value === "object" ? JSON.stringify(value) : value }))} />
        <Descriptions bordered column={2} title="設定・契約" items={[
          { key: "mode", label: "モード", children: s.mode }, { key: "license", label: "ライセンス", children: s.license_state },
          { key: "relay", label: "リレー", children: `${s.relay.host}:${s.relay.port} (${s.relay.auth})` },
          { key: "credentials", label: "リレー資格情報", children: s.relay.credentials_set ? "設定済み" : "未設定" },
          { key: "domains", label: "自社ドメイン", children: s.own_domains.join(", ") || "未設定" },
        ]} />
        {s.files && <>
          <Descriptions bordered column={2} title="添付のダウンロードリンク" items={[
            { key: "host", label: "公開口", children: s.files.host_configured ? "設定済み" : <Tag color="warning">未設定</Tag> },
            { key: "selector", label: "DKIM セレクタ", children: s.files.dkim.selector || "—" },
            { key: "active", label: "有効なリンク", children: s.files.links_active },
            { key: "stuck", label: "送出前のまま 48 時間超", children: s.files.links_prepared_stuck ? <Tag color="warning">{s.files.links_prepared_stuck}</Tag> : 0 },
            { key: "downloads", label: "24 時間のダウンロード", children: s.files.downloads_24h },
            { key: "bytes", label: "リンク化した添付のスプール(bytes)", children: s.files.spool_files_bytes },
            { key: "shelved", label: "復元で退避した件数 / bytes / 最古", children: `${s.files.shelved_restores.count} / ${s.files.shelved_restores.bytes} / ${s.files.shelved_restores.oldest_at ?? "—"}` },
            { key: "pending", label: "署名セレクタごとの未完了メール(旧セレクタの鍵・DNS を外す判断用)", children: s.files.dkim.pending_selectors.length ? s.files.dkim.pending_selectors.map((p) => `${p.selector} (${p.count})`).join(", ") : "なし" },
          ]} />
          <Table scroll={{ x: "max-content" }} size="small" rowKey="domain" title={() => "DKIM の DNS 確認(自社ドメインごと)"} dataSource={s.files.dkim.domains} pagination={false} columns={[
            { title: "ドメイン", width: 240, dataIndex: "domain" },
            { title: "状態", width: 110, render: (_, d) => <Tag color={d.state === "ok" ? "success" : "warning"}>{d.state === "ok" ? "確認済み" : d.state === "missing" ? "未確認" : d.state}</Tag> },
            { title: "確認日時", width: 240, render: (_, d) => d.checked_at ?? "—" },
          ]} />
        </>}
      </>}
    </Space>
  </div></div>;
}
